import {FaArrowUpRightFromSquare} from "react-icons/fa6";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {DASH_BREAKPOINTS} from "../../../../../utils/responsive-graph.js";

const ActionCard = ({icon, title, subtitle, badge, variant = "default", onClick, reactIcon, smallSub = false}) => {
    const vw = useGraphViewportWidth();
    const isCompact = vw < DASH_BREAKPOINTS.desktop;

    const variantClass = variant === "alert"
        ? "from-[#FFDADA] to-white border border-red-200/60"
        : "from-[#CEE7FF] to-white";

    const _icon = reactIcon;

    return (
        <div
            onClick={onClick}
            className={"group cursor-pointer relative h-full w-full text-left rounded-lg p-5 bg-linear-to-b shadow-md hover:shadow-xl transition-shadow " + (isCompact ? "max-h-[180px] " : "max-h-[200px] ") + variantClass}
        >
            <span
                aria-hidden
                className="absolute top-3 right-3 size-9 rounded-full bg-white flex items-center justify-center shadow-sm transition-colors">
                <FaArrowUpRightFromSquare className="text-slate-700  transition-colors" size={14}/>
            </span>

            <div className="flex w-full min-w-0 items-start gap-4 pr-10">
                {
                    !!icon && <img src={getAssetPath(icon)} alt={""} className={(isCompact ? "h-(--font-2xl)" : "h-10") + " shrink-0"}/>
                }
                {
                  !icon && !!reactIcon && <_icon className="shrink-0" size={isCompact ? "20" : "40"} color="#003A6C"/>
                }

                <div className="flex min-w-0 flex-1 flex-col">
                    <h2 lang="pt-BR" className={"text-[#031B35] font-normal! leading-tight m-0! mb-1! hyphens-auto " + (isCompact ? "text-(length:--font-lg)!" : "text-[24px]!")}>
                        {title}
                    </h2>
                    {badge}
                    {!badge && subtitle && (
                        <p className={"text-[#676767] m-0! " + (smallSub ? "text-[14px]!" : "text-(length:--font-md)!")}>
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ActionCard;
